<template>
  <div class="dealer-name-marquee dealer-name-marquee-footer" :data-brand="brand.substr(0,1).toLowerCase() + brand.substr(1)">
    <div class="marquee-wrapper">
      <div class="marquee-line top">
        <div class="marquee-inner">
          <span class="primary-dark-color">HOMETOWN </span><span class="secondary-color">{{ dealerLabel }} </span>
        </div>
      </div>

      <div class="marquee-line bottom">
        <div class="marquee-inner">
          <span class="primary-dark-color">HOMETOWN </span><span class="secondary-color">{{ dealerLabel }} </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import "../../static/bootstrap-3.3.7-dist/js/bootstrap.min.js";

  export default {
    computed: {
      brand() {
        return this.$store.state.chosenBrand;
      },

      dealerLabel() {
        const brand = this.brand
          ? this.brand.toLowerCase()
          : '';

        const labels = {
          cjdr: 'CDJR'
        };

        return labels[brand] || brand.toUpperCase() || 'DEALER';
      }
    },
    mounted() {
      function setupTicker(selector, direction, numCopies = 9, initialOffset = 0) {
        const inner = document.querySelector(selector);
        if (!inner) return;

        const content = inner.innerHTML;
        inner.innerHTML = content.repeat(numCopies);

        let x = initialOffset;
        let lastScrollY = window.scrollY;
        let active = false;

        const observer = new IntersectionObserver(entries => {
          active = entries[0].isIntersecting;
        });
        observer.observe(inner.parentElement);

        window.addEventListener("scroll", () => {
          if (!active) {
            lastScrollY = window.scrollY;
            return;
          }

          const delta = window.scrollY - lastScrollY;
          lastScrollY = window.scrollY;

          x += delta * direction;
          inner.style.transform = `translateX(${x}px)`;
        });
      }

      const topSelector =
        ".dealer-name-marquee-footer .marquee-line.top .marquee-inner";
      const bottomSelector =
        ".dealer-name-marquee-footer .marquee-line.bottom .marquee-inner";

      const topOffset = window.innerWidth - 3000;
      const bottomOffset = -window.innerWidth * 1.2;

      setupTicker(topSelector, -1, 9, topOffset);
      setupTicker(bottomSelector, 1, 9, bottomOffset);
    }
  }
</script>

<style lang="scss" scoped>
  @import '@/assets/styles/sokal-utility-classes.scss';
  @import '@/assets/styles/sokal-modern-styles.scss';
  @import '@/assets/styles/modern-utility-classes.scss';
  @import '@/assets/styles/sokal_utility_classes_responsive.scss';
</style>

<style scoped>
  .dealer-name-marquee-footer .marquee-wrapper {
    width: 100%;
    overflow: hidden;
    background: url("https://d2v1gjawtegg5z.cloudfront.net/uploads/files/001/866/637/original/grid-pattern.png?1768410421")repeat,radial-gradient(circle, rgba(6, 111, 239, 0.18) 0%, rgba(6, 111, 239, 0.05) 45%, rgba(255, 255, 255, 0.9) 80%, rgba(255, 255, 255, 1) 100%);
    color: #fff;
    padding: 20px 0;
    font-size: 120px;
  }

  .dealer-name-marquee-footer .marquee-line {
    overflow: hidden;
    white-space: nowrap;
    position: relative;
    line-height: 110px;
  }

  .dealer-name-marquee-footer .marquee-inner {
    display: inline-block;
    font-weight: 900;
    white-space: nowrap;
    font-family: var(--large-text);
    position: relative;
    left: 0;
  }
  .dealer-name-marquee-footer .primary-dark-color {
    color: var(--primary-dark);
  }
  .dealer-name-marquee-footer .secondary-color {
    color: var(--secondary-color);
  }

  /* CJDR */
  .dealer-name-marquee-footer[data-brand="cjdr"] .marquee-wrapper {
    background: none;
  }
  .dealer-name-marquee-footer[data-brand="cjdr"] :deep(.marquee-inner) {
    font-weight: 700;
    font-style: normal;
  }
</style>